import { Component, Input } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
    selector: 'app-bottom-buttons',
    templateUrl: './bottom-buttons.component.html',
    styleUrls: ['./bottom-buttons.component.scss']
})
export class BottomButtonsComponent {
    @Input() backUrl: string;

    @Input() backUrlText = 'Terug';

    @Input() nextUrl: string;

    @Input() nextUrlText = 'Volgende';

    @Input() classType = 'experience';

    constructor(private navController: NavController) { }

    goBack() {
    	this.navController.navigateBack(this.backUrl);
    }

    goNext() {
    	this.navController.navigateBack(this.nextUrl);
    }
}
